import { render } from "./ScaleTareItem.vue?vue&type=template&id=0a17b57d&ts=true"
import script from "./ScaleTareItem.vue?vue&type=script&lang=ts"
export * from "./ScaleTareItem.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ScaleTareItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a17b57d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a17b57d', __exports__)) {
    api.reload('0a17b57d', __exports__)
  }
  
  module.hot.accept("./ScaleTareItem.vue?vue&type=template&id=0a17b57d&ts=true", () => {
    api.rerender('0a17b57d', render)
  })

}


export default __exports__